import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";
import {TransmissionInterface} from "../../features/user/project/parameters/transmission-interface";

@Exclude()
export class TransmissionApiModel extends AbstractDictionaryApiModel implements TransmissionInterface{
  @Expose() gearboxType: string;
  @Expose() gears: number;
}
